import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "../redux/store";
import RestrictedRoutes from "./AppRouter";
import PublicRoutes from "../router";
import CustomLogout from "../components/CustomLogout/CustomLogout";

import "./App.css";
// import "antd/dist/antd.css";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <CustomLogout />
        {/* <PublicRoutes /> */}
        <RestrictedRoutes />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
